(function (ws, $, globals) {
    'use strict';

    ws.views.quoteTableTooltip = Backbone.View.extend({

        className: 'comp-table-tooltip',

        /**
         * Initialize
         */
        initialize: function () {
            this.eventAgg = globals.eventAgg;
            this.eventAgg.on('quoteTableTooltip', this.setProps.bind(this));

            this.render();
        },

        getValFromTooltip: function(e) {
            var val = $(e.currentTarget).val();
            this.eventAgg.trigger('getDataFromTooltip', e, val, undefined, this.options.currentRow);
        },

        /**i
         * Set Props
         * @param {Object} options
         */
        setProps: function (options) {
            this.options = options;
            this.update();
        },

        /**i
         * Render Tooltip
         */
        render: function () {
            $('body').append(this.$el);
        },

        /**
         * Update Tooltip
         */
        update: function () {
            switch ('html' in this.options) {
                case true:
                    this.$el.html(this.options.html);
                    break;

                default:
                    this.$el.html(this.options.template(this.options.model || {}));
            }

            this.bindEvents();
            this.position();
        },

        /**
         * Bind Tooltip Events
         */
        bindEvents: function () {
            this.mouseout = function () {
                this.$el.hide();

                if ('onClose' in this.options) {
                    this.options.onClose();
                }

                this.options.follow.removeEventListener('mouseout', this.mouseout, false);
            }.bind(this);

            this.options.follow.addEventListener('mouseout', this.mouseout);
        },

        /**
         * Set Tooltip Position
         */
        position: function () {
            var position = this.options.follow.getBoundingClientRect();
            if (this.options.model && this.options.model.column.columnName == 'totalLandedCost') {
                this.$el.addClass('totalLandedCost');
                this.$el.css({ top: position.top + (position.height / 2), right: 215, left: 560 }).show();
            } else {
                this.$el.css({ top: position.top + (position.height / 2), left: position.left + this.options.follow.offsetWidth + 5 }).show();
            }
        }

    });
})(westcon, jQuery, globals);
